import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { StoreUpdatePricingRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const NULLABLE_NUMBER = ['minimum_order', 'delivery_fee'] as const

// UpdateStorePricingRequest::prepareForValidation
const normalize = fieldNormalizer({ blankToNull: NULLABLE_NUMBER })

const schema = StoreUpdatePricingRequestSchema.strict()

export const StoreUpdatePricing = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema)
